import { createHook, createStore, createContainer } from '@atlassian/react-sweet-state';
import actions from './actions';
import { defaultFilter as defaultIssueTypeScreenSchemesFilter } from './actions/utils';
import type {
	IssueTypeScreenSchemesServiceState,
	IssueTypeScreenSchemesServiceContainerProps,
} from './types';

export type IssueTypeScreenSchemesServiceActions = typeof actions;

const initialState: IssueTypeScreenSchemesServiceState = {
	issueTypeScreenSchemes: {
		values: [],
		maxResults: 0,
		startAt: 0,
		total: 0,
		isLast: false,
		isLoading: false,
		isError: false,
		error: undefined,
	},
	filter: defaultIssueTypeScreenSchemesFilter,
};

const Store = createStore<IssueTypeScreenSchemesServiceState, IssueTypeScreenSchemesServiceActions>(
	{
		name: 'jira-admin-issue-type-screen-schemes',
		initialState,
		actions,
	},
);
export const useIssueTypeScreenSchemesService = createHook(Store);

const IssueTypeScreenSchemesServiceContainer = createContainer<
	IssueTypeScreenSchemesServiceState,
	IssueTypeScreenSchemesServiceActions,
	IssueTypeScreenSchemesServiceContainerProps
>(Store);

export default IssueTypeScreenSchemesServiceContainer;
